export const capitalize = (str: string) => {
  return str.replace(/^\w/, (c) => c.toUpperCase());
};
